import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "createRoom",
  tabindex: "-1",
  "aria-labelledby": "createRoom",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editGroup"
}
const _hoisted_6 = { class: "row mx-5 px-0 pb-4 gx-3 my-4 justify-content-lg-center" }
const _hoisted_7 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_8 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_9 = { class: "col-lg-7" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_12 = { class: "row mx-5 px-0 gx-3 justify-content-lg-center" }
const _hoisted_13 = { class: "w-max-content col-lg-5 col-form-label fw-bold" }
const _hoisted_14 = { class: "col-lg-7 mb-5" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_17 = { class: "row mb-5 fs-7 mx-5 px-0 gx-3" }
const _hoisted_18 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_19 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_20 = { class: "row ps-3 mx-0 col-lg-7 mt-2 d-flex" }
const _hoisted_21 = { class: "form-check col-lg-3" }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "form-check col-lg-6" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_28 = {
  class: "modal fade",
  id: "confirmCreateRoomModal",
  tabindex: "-1",
  "aria-labelledby": "confirmCreateRoomModal",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog modal-lg" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header" }
const _hoisted_32 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmCreateRoomModal"
}
const _hoisted_33 = { class: "modal-body" }
const _hoisted_34 = { class: "row mb-5 mt-3 px-3" }
const _hoisted_35 = { class: "col-lg-4 fw-bold" }
const _hoisted_36 = { class: "col-lg-8" }
const _hoisted_37 = { class: "row mb-5 px-3" }
const _hoisted_38 = { class: "col-lg-4 fw-bold" }
const _hoisted_39 = { class: "col-lg-8" }
const _hoisted_40 = { class: "text-break break-spaces" }
const _hoisted_41 = { class: "row mb-3 px-3" }
const _hoisted_42 = { class: "col-lg-4 fw-bold" }
const _hoisted_43 = { class: "col-lg-8" }
const _hoisted_44 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_45 = {
  class: "modal fade",
  id: "successCreateRoom",
  tabindex: "-1",
  "aria-labelledby": "successCreateRoom",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "modal-dialog" }
const _hoisted_47 = { class: "modal-content" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = {
  class: "modal-title text-center fw-bold w-100",
  id: "successCreateRoom"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_51 = { class: "" }
const _hoisted_52 = { class: "text-center my-4" }
const _hoisted_53 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, maxLength, minLength } from '@vuelidate/validators'
import groupsService from '@/services/groups.service'
//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { customMaxLength } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const loadingCreate = ref<boolean>(false)
const createFailed = ref<boolean>(false)
const modalCreate = ref()
const modalConfirm = ref()
const modalComplete = ref()

onMounted(() => {
  modalCreate.value = new Modal(document.getElementById('createRoom'))
  modalConfirm.value = new Modal(document.getElementById('confirmCreateRoomModal'))
  modalComplete.value = new Modal(document.getElementById('successCreateRoom'))
})

const rules = computed(() => {
  return {
    name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 30),
      minLength: minLength(DEFAULT_MIN_LENGTH),
    },
    information: {
      maxString: (value: string) => customMaxLength(value, 200),
    },
    published: { required },
  }
})

const formData = ref({
  name: '',
  information: '',
  published: true,
  create_by_community_admin: true,
})

const v$ = useVuelidate(rules, formData)
const loading = ref(false)

const resetForm = () => {
  v$.value.$reset()
  Object.assign(formData.value, {
    name: '',
    information: '',
    published: true,
  })
  ngKeyName.value = false
  ngKeyInfo.value = false
}

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loading.value = true

  isCheckedNGKeyName.value = false
  isCheckedNGKeyInfo.value = false
  await checkNGKeyName()
  await checkNGKeyInfo()
  while (!isCheckedNGKeyName.value || !isCheckedNGKeyInfo.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v$.value.$invalid || ngKeyName.value || ngKeyInfo.value) {
    loading.value = false
    return
  }

  modalCreate.value.hide()
  modalConfirm.value.show()
  loading.value = false
}

const CreateRoom = async () => {
  loadingCreate.value = true
  try {
    const response = await groupsService.createTalkRoom(route?.params?.group_id, {
      create_by_community_admin: true,
      talkroom: formData.value,
      create_by_admin: true,
    })
    if (response?.data?.success) {
      v$.value.$reset()
      createFailed.value = false
      Object.assign(formData.value, {
        name: '',
        information: '',
        published: true,
      })
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_TALK_ROOMS, {
        id: route.params?.group_id,
        params: {
          ...route.query,
          page: route.query?.page || 1,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      })
    } else {
      createFailed.value = true
    }
    modalConfirm.value.hide()
    modalComplete.value.show()
    // 2022/09/12 TienNV Fix double click button confirm create talkRoom
    setTimeout(() => {
      loadingCreate.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    loadingCreate.value = false
    createFailed.value = true
  }
}

const isCheckedNGKeyName = { value: false }
const ngKeyName = ref<boolean>(false)
const checkNGKeyName = debounce(async () => {
  const queryData = { sentence: v$.value.name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyName.value = true
  }
}, 200)

const isCheckedNGKeyInfo = { value: false }
const ngKeyInfo = ref<boolean>(false)
const checkNGKeyInfo = debounce(async () => {
  const queryData = { sentence: v$.value.information.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyInfo.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyInfo.value = true
  }
}, 200)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Button, {
      title: _unref(translate)('createTalkRooms'),
      "data-bs-Toggle": "modal",
      "data-bs-target": "#createRoom",
      type: 'secondary',
      onClick: resetForm
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OD20createTitle')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetForm
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('talkRoomName')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "name",
                  class: _normalizeClass(['form-control', ngKeyName.value || _unref(v$).name.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyName) && _unref(checkNGKeyName)(...args))),
                  placeholder: _unref(translate)('placeholder')
                }, null, 42, _hoisted_10), [
                  [
                    _vModelText,
                    _unref(v$).name.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyName.value && !_unref(v$).name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('talkRoomName'),
                  validator: _unref(v$).name.$errors[0]?.$validator,
                  params: [1, 30]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('OD20talkRoomDes')), 1),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  name: "information",
                  class: _normalizeClass(['form-control', ngKeyInfo.value || _unref(v$).information.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).information.$model) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyInfo) && _unref(checkNGKeyInfo)(...args))),
                  placeholder: _unref(translate)('placeholder')
                }, null, 42, _hoisted_15), [
                  [
                    _vModelText,
                    _unref(v$).information.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyInfo.value && !_unref(v$).information.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('OD20talkRoomDes'),
                  validator: _unref(v$).information.$errors[0]?.$validator,
                  params: [200]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.public
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.public,
                      value: true,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_23), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                  ], 8, _hoisted_22)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.private
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.private,
                      value: false,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_26), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                  ], 8, _hoisted_25)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                class: "me-lg-3",
                "data-bs-dismiss": "modal",
                className: 'fw-bold',
                onClick: resetForm
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                onClick: onSubmit,
                disabled: loading.value,
                loading: loading.value,
                className: 'fw-bold'
              }, null, 8, ["title", "disabled", "loading"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h5", _hoisted_32, _toDisplayString(_unref(translate)('OD20createTitle')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetForm
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(translate)('talkRoomName')), 1),
                _createElementVNode("div", _hoisted_36, _toDisplayString(formData.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(translate)('OD20talkRoomDes')), 1),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", _hoisted_40, _toDisplayString(formData.value.information), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(translate)('publicSettings')), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(formData.value.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                dataBsToggle: 'modal',
                dataBsTarget: '#createRoom',
                class: "me-lg-3",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('OD21Register'),
                type: 'secondary',
                onClick: CreateRoom,
                loading: loadingCreate.value,
                disabled: loadingCreate.value,
                className: 'fw-bold'
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("h5", _hoisted_49, _toDisplayString(_unref(translate)('OD20createTitle')), 1),
            _hoisted_50
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("p", _hoisted_52, _toDisplayString(createFailed.value ? _unref(translate)('SO10createTalkRoomError') : _unref(translate)('SO10createTalkRoomSuccess')), 1)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})